import { TaskTemplate } from '@awork/features/task/models/task-template.model'
import type { Task } from '@awork/features/task/models/task.model'

export const NO_LIST_ORDER = 99999

/**
 * Task Bundle
 */
export class TaskListTemplate {
  id: string
  name: string
  order: number
  orderOfTask: number
  tasks: TaskTemplate[]
  isHiddenForConnectUsers?: boolean

  constructor(taskList: Partial<TaskListTemplate>) {
    Object.assign(this, taskList)

    this.tasks = this.tasks?.map(task => new TaskTemplate(task))
  }

  /**
   * Determines if is a real list (not a 'Without list' list)
   * @returns {boolean}
   */
  get isRealList(): boolean {
    return this.order !== NO_LIST_ORDER
  }

  setOrderOfTask(tasks: Task[]): void {
    const nTasks = tasks ? tasks.length : 0

    // Set the order as the last one in the list
    // (the one before this new task that is already pushed to the array, hence `nTasks - 2`)
    if (nTasks > 1) {
      const lastTaskList = tasks[nTasks - 2].lists.find(list => list.id === this.id)

      if (lastTaskList) {
        this.orderOfTask = lastTaskList.orderOfTask + 1
      }
    } else {
      this.orderOfTask = 0
    }
  }
}
